/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from 'ngx-bootstrap/modal/modal-container.component';
import * as i2 from 'ngx-bootstrap/modal/modal-options.class';
import * as i3 from 'ngx-bootstrap/modal/bs-modal.service';
const styles_ModalContainerComponent:any[] = ([] as any[]);
export const RenderType_ModalContainerComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_ModalContainerComponent,data:{}});
export function View_ModalContainerComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted(-1,(null as any),['\n    '])),(_l()(),i0.ɵeld(1,
      0,(null as any),(null as any),4,'div',[['role','document']],[[8,'className',
          0]],(null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted(-1,
      (null as any),['\n      '])),(_l()(),i0.ɵeld(3,0,(null as any),(null as any),
      1,'div',[['class','modal-content']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),i0.ɵncd((null as any),0),(_l()(),i0.ɵted(-1,(null as any),
      ['\n    '])),(_l()(),i0.ɵted(-1,(null as any),['\n  ']))],(null as any),(_ck,
      _v) => {
    var _co:i1.ModalContainerComponent = _v.component;
    const currVal_0:any = ('modal-dialog' + (_co.config.class? (' ' + _co.config.class): ''));
    _ck(_v,1,0,currVal_0);
  });
}
export function View_ModalContainerComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'modal-container',
      [['class','modal'],['role','dialog'],['tabindex','-1']],(null as any),[[(null as any),
          'click'],['window','keydown.esc']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1).onClick($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('window:keydown.esc' === en)) {
          const pd_1:any = ((<any>i0.ɵnov(_v,1).onEsc()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },View_ModalContainerComponent_0,RenderType_ModalContainerComponent)),i0.ɵdid(1,
      245760,(null as any),0,i1.ModalContainerComponent,[i2.ModalOptions,i0.ElementRef,
          i3.BsModalService,i0.Renderer],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const ModalContainerComponentNgFactory:i0.ComponentFactory<i1.ModalContainerComponent> = i0.ɵccf('modal-container',
    i1.ModalContainerComponent,View_ModalContainerComponent_Host_0,{},{},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL0NocmlzL0RvY3VtZW50cy9XZWJEZXYvRGV2R2VuQW5nL25vZGVfbW9kdWxlcy9uZ3gtYm9vdHN0cmFwL21vZGFsL21vZGFsLWNvbnRhaW5lci5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vVXNlcnMvQ2hyaXMvRG9jdW1lbnRzL1dlYkRldi9EZXZHZW5Bbmcvbm9kZV9tb2R1bGVzL25neC1ib290c3RyYXAvbW9kYWwvbW9kYWwtY29udGFpbmVyLmNvbXBvbmVudC5kLnRzIiwibmc6Ly8vVXNlcnMvQ2hyaXMvRG9jdW1lbnRzL1dlYkRldi9EZXZHZW5Bbmcvbm9kZV9tb2R1bGVzL25neC1ib290c3RyYXAvbW9kYWwvbW9kYWwtY29udGFpbmVyLmNvbXBvbmVudC5kLnRzLk1vZGFsQ29udGFpbmVyQ29tcG9uZW50Lmh0bWwiLCJuZzovLy9Vc2Vycy9DaHJpcy9Eb2N1bWVudHMvV2ViRGV2L0RldkdlbkFuZy9ub2RlX21vZHVsZXMvbmd4LWJvb3RzdHJhcC9tb2RhbC9tb2RhbC1jb250YWluZXIuY29tcG9uZW50LmQudHMuTW9kYWxDb250YWluZXJDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCJcbiAgICA8ZGl2IFtjbGFzc109XCInbW9kYWwtZGlhbG9nJyArIChjb25maWcuY2xhc3MgPyAnICcgKyBjb25maWcuY2xhc3MgOiAnJylcIiByb2xlPVwiZG9jdW1lbnRcIj5cbiAgICAgIDxkaXYgY2xhc3M9XCJtb2RhbC1jb250ZW50XCI+PG5nLWNvbnRlbnQ+PC9uZy1jb250ZW50PjwvZGl2PlxuICAgIDwvZGl2PlxuICAiLCI8bW9kYWwtY29udGFpbmVyPjwvbW9kYWwtY29udGFpbmVyPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUEsOENBQ0k7TUFBQTtVQUFBLDhEQUF5RjtNQUFBLDZCQUN2RjtNQUFBO01BQUEscUNBQTJCLGtCQUErQjtNQUFBLGFBQ3REOzs7SUFGRDtJQUFMLFdBQUssU0FBTDs7OztvQkNESjtNQUFBO1VBQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtNQUFBLDZFQUFBO01BQUE7dUNBQUE7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/node_modules/ngx-bootstrap/modal/modal-container.component.ngfactory.ts